/*
 * Batch prompt + cast extraction. Single Gemini call returns one scene per
 * prompt with `referencedSceneIndices` so the frontend can wire smart auto-
 * linking in one pass. See IMPLEMENTATION_PLAN.md §4 "Smart auto-link".
 *
 * Phase 4 frontend hits POST /api/episode/{uuid}/v2/batch-prompts. Phase 7
 * LocalBackend can proxy to Gemini directly using the uploaded SA key.
 */

import type { Character } from '@/types';
import { apiFetch } from './apiBase';

export interface ProposedScene {
  prompt: string;
  /** 1-indexed positions inside this same array; resolved to Scene.id on insert. */
  referencedSceneIndices: number[];
}

export interface ProposedCast {
  name: string;
  description: string;
  type: Character['type'];
}

export interface BatchPromptsResult {
  scenes: ProposedScene[];
  cast: ProposedCast[];
}

export async function generateScenePromptsFromText(
  episodeUuid: string,
  text: string,
  options: { extractCast: boolean },
): Promise<BatchPromptsResult> {
  const res = await apiFetch(
    `/api/episode/${encodeURIComponent(episodeUuid)}/v2/batch-prompts`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text, extractCast: options.extractCast }),
    },
  );
  if (!res.ok) throw new Error(`batchPrompts failed: ${res.status}`);
  return res.json();
}
